<ngx-invisible-recaptcha
  #captchaElem
  [siteKey]="recaptchaSiteKey"
  (success)="onRecaptchaSuccess($event)"
  [ngModel]="recaptcha"
  [ngModelOptions]="{ standalone: true }"
  ngDefaultControl
>
</ngx-invisible-recaptcha>
